<template>
    <div >
        <div class="title">{{ $t('full.message') }}</div>
        <img class="status-icon" src="../../assets/warning.svg"/>
        <div class="action">{{ $t('full.callToAction') }}</div>
        <forecast/>
    </div>
</template>

<script>
  import Forecast from './Forecast';
  export default {
    name: 'OccupancyFull',
    components: {Forecast}
  };
</script>
